/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Mobile Nav Toggle

http://getbootstrap.com/javascript/#collapse

*/

import 'bootstrap/js/collapse';


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Custom Navigation Dropdown and Tweaks

*/

function initNavigation() {

    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

    Toggle a class when mobile nav is expanded

    */

    // init
    var $html = $('html');
    var $site_menu_toggle = $('.site-menu-toggle');
    var nav_expanded_class = 'nav-expanded';
    var toggled_attr = 'data-softpage-toggled';
    var toggled_class = 'is-active';

    // softpage menu toggle
    $site_menu_toggle.on('click',function(e){
        // init
        var $toggle = $(this);
        e.preventDefault();
        // already active
        if ($toggle.hasClass(toggled_class)) {
            $toggle.removeClass(toggled_class);
            $(window).trigger('closeDefaultModal');
        }
        // about to toggle
        else {
            $html.addClass(nav_expanded_class);
            $toggle.addClass(toggled_class);
        }
    });
    $(window).on('default-modal:closed',function(){
        $site_menu_toggle.removeAttr(toggled_attr);
        $site_menu_toggle.removeClass(toggled_class);
        $html.removeClass(nav_expanded_class);
    });


    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

    Toggle subnav on larger screens

    */

    // STEP 1: click anywhere on the DOM hides all subnavs
    $( document ).on( 'click touchend', function(e){

        // init
        var device_width = $( window ).width();
        var min_width_breakpoint = 992; // when is the full menu shown?

        // click on a default subnav
        if( $(e.target).parents('.nav-dropdown').hasClass('opened') ) {
            // don't do anything
        }
        // click on a speicla subnav
        else if( $(e.target).parents('.primary-special-subnav').length > 0 ) {
            // don't do anything
        }
        else {
            if (device_width >= min_width_breakpoint) {
                hideExpandedSubnav();
                // close our special subnav
                hideSpecialSubnav();
            }
        }

    });

    // STEP 2 (overwrites STEP 1): toggle subnav visibility
    $( '.nav-desktop .nav-dropdown > a').on( 'click', function( e ){

        // init
        var $current_subnav = $( this ).siblings( '.subnav' );
        var $overlay = $( '.content-overlay' );
        var visible_class = 'visible';
        var device_width = $( window ).width();
        var min_width_breakpoint = 992; // when is the full menu shown?

        // stops climbing up the DOM, which overwrites STEP 1
        e.stopPropagation();

        // stop following the link
        e.preventDefault();

        // check if current subnav is visible
        var child_is_visible = $current_subnav.hasClass(visible_class);

        // hide all previously opened subnavs
        hideExpandedSubnav();

        // second, display the subnav if it was NOT visible before
        if(child_is_visible) {
            $current_subnav.removeClass(visible_class);
            $current_subnav.parents('.nav-dropdown').removeClass('opened');
            if( device_width >= min_width_breakpoint ) {
                $overlay.removeClass(visible_class);
            }
        }else {
            $current_subnav.addClass(visible_class);
            $current_subnav.parents('.nav-dropdown').addClass('opened');
            if( device_width >= min_width_breakpoint ) {
                $overlay.addClass(visible_class);
            }
        }

    });

    // STEP 2 (overwrites STEP 1): toggle subnav visibility
    $( '.nav-mobile .nav-dropdown > a').on( 'click', function( e ){

        // init
        var $current_subnav_container = $( this ).siblings( '.subnav-container' );
        var $overlay = $( '.content-overlay' );
        var visible_class = 'visible';
        var device_width = $( window ).width();
        var min_width_breakpoint = 992; // when is the full menu shown?
        var transition_duration = 200; // transition duration defined in CSS

        // stops climbing up the DOM, which overwrites STEP 1
        e.stopPropagation();

        // stop following the link
        e.preventDefault();

        // check if current subnav is visible
        var child_is_visible = $current_subnav_container.hasClass(visible_class);

        // hide all previously opened subnavs
        if (device_width >= min_width_breakpoint) {
            hideExpandedSubnav();
        }

        // second, display the subnav if it was NOT visible before
        if(child_is_visible) {
            $current_subnav_container.css('height','');
            $current_subnav_container.removeClass(visible_class);
            const $parent_dropdown = $current_subnav_container.parents('.nav-dropdown').first();
            $parent_dropdown.removeClass('opened');
            setTimeout(function(){
                const $parent_subnav_container = $parent_dropdown.parents('.subnav-container').first();
                const new_parent_subnav_height = $parent_subnav_container.find('.subnav').first().outerHeight();
                $parent_subnav_container.css('height',new_parent_subnav_height);
            },transition_duration);
            if( device_width >= min_width_breakpoint ) {
                $overlay.removeClass(visible_class);
            }
        }else {
            const subnav_height = $current_subnav_container.find('.subnav').outerHeight();
            $current_subnav_container.addClass(visible_class);
            $current_subnav_container.css('height',subnav_height);
            const $parent_dropdown = $current_subnav_container.parents('.nav-dropdown').first();
            $parent_dropdown.addClass('opened');
            // update parent container
            setTimeout(function(){
                const $parent_subnav_container = $parent_dropdown.parents('.subnav-container').first();
                const new_parent_subnav_height = $parent_subnav_container.find('.subnav').first().outerHeight();
                $parent_subnav_container.css('height',new_parent_subnav_height);
            },transition_duration);
            if( device_width >= min_width_breakpoint ) {
                $overlay.addClass(visible_class);
            }
        }

    });

    // STEP 2 (overwrites STEP 1): toggle subnav visibility
    $( '.nav-dropdown-special > a').on( 'click', function( e ){

        // init
        var $trigger = $(this);
        var level = $trigger.parents('.nav-dropdown-special').first().attr('data-level');
        var $container = $('.primary-special-subnav');
        var $current_subnav = $( this ).siblings( '.subnav' );
        var $overlay = $( '.content-overlay' );
        var visible_class = 'visible';
        var device_width = $( window ).width();
        var min_width_breakpoint = 992; // when is the full menu shown?

        // stops climbing up the DOM, which overwrites STEP 1
        e.stopPropagation();

        // stop following the link
        e.preventDefault();

        // check if current subnav is visible
        var child_is_visible = $current_subnav.hasClass(visible_class);

        // first of all: hide all previously opened subnavs of SAME LEVEL
        $container.find('.nav-dropdown-special[data-level="'+level+'"]').removeClass('opened');

        // set active
        $current_subnav.addClass(visible_class);
        $current_subnav.parents('.nav-dropdown-special').first().addClass('opened');
        if( device_width >= min_width_breakpoint ) {
            $overlay.addClass(visible_class);
        }

    });

    // Optional: Selector of an element that closes the nav
    $( '.subnav-close').on( 'click', function(e){
        e.preventDefault();
        hideExpandedSubnav();
    });

    // Close Subnave when hitting ESC
    $(document).keydown(function(evt) {
        evt = evt || window.event;
        var isEscape = false;
        if ("key" in evt) {
            isEscape = evt.key == "Escape";
        } else {
            isEscape = evt.keyCode == 27;
        }
        if (isEscape) {
            hideExpandedSubnav();
            // close our special subnav
            hideSpecialSubnav();
        }
    });

}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Touch device navigation fixes

*/

function hideExpandedSubnav() {

    // init
    var device_width = $( window ).width();
    var visible_class = 'visible';
    var $overlay = $( '.content-overlay' );
    var min_width_breakpoint = 992; // when is the full menu shown?

    // hide overlay
    $overlay.removeClass(visible_class);

    // only apply on expanded navigation
    if( device_width >= min_width_breakpoint ) {
        $('.subnav').each(function(){
            var $this = $(this);
            if( $this.hasClass(visible_class) ) {
                if($this.parents(''))
                $this.removeClass(visible_class);
                $this.parents('.nav-dropdown').removeClass('opened');
            }
        });
    }

}


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Special Subnav

*/

function initSpecialSubnavTrigger() {
    $('[data-trigger-special-nav]').on('click',function(e){

        // init
        var $trigger = $(this);
        var opened_class = 'opened';

        // if opened already, time to close!
        if ($trigger.parents('.nav-dropdown').hasClass(opened_class)) {
            // close
            hideSpecialSubnav();
        }
        // otherwise, do the magic
        else {
            // set link active state
            $trigger.parents('.nav-dropdown').addClass(opened_class);
            // classes and selectors
            var subnav_container_class = 'primary-special-subnav';
            var subnav_container_selector = '.'+subnav_container_class;
            var subnav_container_active_class = subnav_container_class+'--visible';
            // get ID of trigger
            var trigger_id = $trigger.attr('data-page-id');
            // containers
            var $subnav_container = $(subnav_container_selector);
            // 1. set items to visible
            $subnav_container.find('[data-parent-page-id="'+trigger_id+'"]').each(function(){
                // init
                var $item = $(this);
                // show item
                $item.show();
                // and its kids
                $item.find('li').show();
            });
            // 2. set container to visible
            $subnav_container.addClass(subnav_container_active_class);
        }

    });
}

function hideSpecialSubnav() {

    // init
    var trigger_selector = '[data-trigger-special-nav]';
    var subnav_container_class = 'primary-special-subnav';
    var subnav_container_selector = '.'+subnav_container_class;
    var subnav_container_active_class = subnav_container_class+'--visible';
    var $subnav_container = $(subnav_container_selector);
    var opened_class = 'opened';
    // set menu item to inactive
    $(trigger_selector).parents('.nav-dropdown').removeClass(opened_class);
    // remove container's visible class
    $subnav_container.removeClass(subnav_container_active_class);
    // reset subnav item visibility
    // IMPORTANT: This have to be synched with the CSS transition-duration
    setTimeout(function(){
        // but only if the navigation has not been set to visible in the meanwhile
        if ($subnav_container.hasClass(subnav_container_active_class) === false) {
            $subnav_container.find('li').hide();
        }
    },600);

}


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Init

*/

$(function(){

    // on page load
    initNavigation();
    initSpecialSubnavTrigger();

    // custom events
    $(window).on('initNavigation', function() {
        initNavigation();
    });

    $(window).on('hideExpandedSubnav', function() {
        hideExpandedSubnav();
    });

    // initialize again when viewport width has changed
    $(window).on('viewportWidthHasChanged', function(){
        hideExpandedSubnav();
    });

});



// WEBPACK FOOTER //
// ./static/js/modules/navigation.js